export default {
  "Login for users": "تسجيل الدخول إلى الحساب",
  Login: "البريد الإلكتروني / الهاتف",
  Password: "كلمة المرور",
  Submit: "تسجيل الدخول",
  "Field required": "الحقل مطلوب",
  "Auth error 400": "بيانات الدخول غير صحيحة",
  "Auth error network":
    "مشكلة في الاتصال. تحقق من اتصال الإنترنت وحاول مرة أخرى.",
  "Auth error unknown": "حدث خطأ. يرجى المحاولة لاحقًا.",
  "Login title": "تسجيل الدخول | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "لا تملك حسابًا؟",
  "Not account yet about":
    "يمكنك إنشاء حساب أو الدخول إلى الوضع التجريبي بإمكانيات محدودة",
  "Demo-mode": "الوضع التجريبي",
  "Let register": "التسجيل",
  "User Agreement Title":
    "اتفاقية المستخدم | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "اتفاقية المستخدم",
  "Privacy policy": "سياسة الخصوصية",
  "User Agreement About part 1": "بمواصلة استخدام الموقع، فإنك توافق على شروط ",
  "User Agreement About part 2": "اتفاقية المستخدم.",
  "User Agree": "أوافق",
  "Page not found": "الصفحة غير موجودة",
  "Page not found about":
    "تم إدخال عنوان خاطئ أو أن الصفحة لم تعد موجودة. عد إلى الصفحة الرئيسية",
  "Back to main page": "العودة إلى الرئيسية",
  "Login for users 2":
    "احصل على وصول كامل إلى وظائف المنصة " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "الخطوة",
  "Min 8": "على الأقل 8 رموز",
  "1 char": "حرف واحد",
  "1 num": "رقم واحد",
  "Auth access 1": "أوافق على ",
  "Auth access 2": "معالجة البيانات الشخصية",
  "Auth access 3": "، وأوافق على شروط ",
  "Auth access 4": "السياسة",
  "Auth access 5": "و",
  "Auth access 6": "اتفاقية المستخدم",
  "Auth access 7": "استلام المواد الإعلانية والمعلوماتية",
  "Have account?": "هل لديك حساب؟",
  "To next": "التالي",
  "Reg for users 1": "إنشاء حساب",
  "Reg for users 2": "أخبرنا عن نفسك",
  "Reg for users 3": "إتمام التسجيل",
  "Your last_name": "اسم العائلة",
  "Your first_name": "الاسم الأول",
  "Your middle_name": "إسمك الأوسط",
  "Your company": "مكان العمل",
  "Your position_in_the_company": "المسمى الوظيفي",
  Back: "رجوع",
  "Min 2": "على الأقل حرفان",
  Promo: "رمز ترويجي (إذا وجد)",
  invitation_1: "من معارف / زملاء",
  invitation_2: "رسائل بريد إلكتروني",
  invitation_3: "بحث في Yandex أو Google",
  invitation_4: "مصدر آخر",
  invitation_5: "وسائل التواصل الاجتماعي",
  "Where know about platform?": "من أين عرفت عن المنصة؟",
  "Reg finish": "تسجيل",
  regErrorText: "فشل في تسجيل المستخدم. يرجى التحقق من البيانات",
  "Auth banner text": "قم بتسجيل الدخول للوصول الكامل إلى وظائف المنصة",
  "Auth banner text 2": "قم بتسجيل الدخول لزيادة عدد الدراسات القابلة للمعالجة",
  "Auth banner text 3": "احصل على معالجة مجانية لـ 10<br/>دراسات خاصة بك",
  "Reg error":
    "عذرًا، لم نتمكن من إتمام التسجيل بسبب خطأ تقني. يرجى المحاولة لاحقًا",
  "Reg error 400": "البريد الإلكتروني مستخدم بالفعل",
  "Rem password": "أدخل البريد الإلكتروني المستخدم عند التسجيل",
  Phone: "الهاتف",
  "Not valid phone": "تنسيق رقم الهاتف غير صالح",
  emailVerify: {
    title: "تأكيد البريد الإلكتروني",
    desc1: "تم إرسال رسالة إلى ",
    desc2:
      " تحتوي على رابط تأكيد. يرجى النقر على الرابط لتفعيل حسابك والوصول إلى الخدمة.",
  },
};
